import { IAdmissionQueryProps } from '@/entities/Admission'
import { IAppointmentQueryProps, IScheduleQueryProps } from '@/entities/Appointment'
import { ICompanyQueryProps } from '@/entities/Company'
import { IDoctorQueryProps } from '@/entities/Doctor'
import { IUserQueryProps } from '@/entities/User'

export const Types = {
  doctor: 'doctor',
  appointment: 'appointment',
  user: 'user',
  admission: 'admission',
  schedule: 'schedule',
  company: 'company'
}

export const path = 'filter/'

export class Doctor implements FluxStandardAction<IDoctorQueryProps | null> {
  type = path + Types.doctor
  constructor(public payload: IDoctorQueryProps | null) {}
}

export class Appointment implements FluxStandardAction<IAppointmentQueryProps | null> {
  type = path + Types.appointment
  constructor(public payload: IAppointmentQueryProps | null) {}
}

export class User implements FluxStandardAction<IUserQueryProps | null> {
  type = path + Types.user
  constructor(public payload: IUserQueryProps | null) {}
}

export class Admission implements FluxStandardAction<IAdmissionQueryProps | null> {
  type = path + Types.admission
  constructor(public payload: IAdmissionQueryProps | null) {}
}

export class Schedule implements FluxStandardAction<IScheduleQueryProps | null> {
  type = path + Types.schedule
  constructor(public payload: IScheduleQueryProps | null) {}
}

export class Company implements FluxStandardAction<ICompanyQueryProps | null> {
  type = path + Types.company
  constructor(public payload: ICompanyQueryProps | null) {}
}
